export default "__VITE_ASSET__DotRFs30__"